module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#int"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#int"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("DETAILS, DETAILS:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Prepping for the Party")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image_bkg"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg10lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GET PLANNING")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg10lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg11lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catering Pointers")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg11lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg11lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inviting Notions")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg11lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg12lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SETTING THE SCENE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg12lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg13lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ideas in Bloom")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg13lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg14lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ORGANIZING THE BUFFET")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg14lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg14lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chafing Dish Primer")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg14lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg15lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAST FIXES")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg15lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg15lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Ways to Make It Snappy")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg15lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg16lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARTENDING—BY THE NUMBERS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg16lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg16lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO FINAL TIPS FOR THE SOUTHERN PARTY HOST")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08part01#pg16lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09part02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09part02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PICK-ME-UPS:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09part02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Handheld Snacks")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09part02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter01#pg20lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FANCIFUL CHEESE STRAWS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter01#pg20lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUST-RIGHT COCKTAIL PECANS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter02#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter03#pg24lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAJUN-SEASONED BOILED PEANUTS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter03#pg24lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter04#pg25lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIED BLACK-EYED PEAS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter04#pg25lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter05#pg26lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEBONAIRE DEVILED EGGS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter05#pg26lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("26")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter06#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MUFFALETTA BITES")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter06#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter07#pg30lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHRIMP & GRITLETS WITH EMERIL’S TOMATO JAM")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter07#pg30lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter07#pg31lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emeril’s Tomato Jam")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter07#pg31lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter08#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RHAPSODY IN BLUE, FIG & RUSTIC HAM")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter08#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter09#pg35lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEE CHICKEN & WAFFLES WITH JEZEBEL-MAPLE SYRUP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter09#pg35lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter10#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BUTTERMILK-BATTERED OKRA FRIES WITH COMEBACK SAUCE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter10#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter11#pg39lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRIED CATFISH PO’ BABIES WITH CREOLE RÉMOULADE SAUCE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter11#pg39lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter12#pg42lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CORNDOG PUPS WITH HONEY OF A MUSTARD SAUCE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter12#pg42lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter13#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIL’ NATCHITOCHES MEAT PIES")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter13#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg47lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stuff of Legend: Finger Sandwiches")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg47lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg47lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inside Scoop")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg47lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg48lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Best Breads")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg48lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("48")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg48lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prep Talk")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg48lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("48")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg49lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Chicken Salad")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter14#pg49lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("49")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24part03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CHAPTER THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24part03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SPREAD THE WORD:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24part03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Dips, Spreads, and Salsas")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24part03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter15#pg52lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEST PIMIENTO CHEESE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter15#pg52lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter16#pg55lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLESTON CHEESE BALL")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter16#pg55lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("55")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter17#pg56lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GIFTED BAKED BRIE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter17#pg56lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter18#pg57lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QUESO FUNDIDO, MY DARLING")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter18#pg57lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter19#pg58lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOODLY RANCH DIP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter19#pg58lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter20#pg59lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CARAMELIZED SWEET ONION DIP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter20#pg59lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter21#pg60lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OYSTERS ROCKEFELLER SPINACH DIP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter21#pg60lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32chapter22#pg61lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEMONY ARTICHOKE-PARMESAN SPREAD")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32chapter22#pg61lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33chapter23#pg62lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CREAMY COLLARD GREENS SPREAD")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33chapter23#pg62lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("62")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34chapter24#pg65lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIVINE CRAB SPREAD")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34chapter24#pg65lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("65")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35chapter25#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOURBONY CHICKEN LIVER PÂTÉ")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35chapter25#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("66")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36chapter26#pg68lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIMA BEAN HUMMUS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36chapter26#pg68lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("68")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37chapter27#pg70lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHUNKY GUACAMOLE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37chapter27#pg70lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("70")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38chapter28#pg71lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROASTED TOMATO SALSA")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38chapter28#pg71lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("71")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39chapter29#pg73lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRAWBERRY-BEET SALSA")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39chapter29#pg73lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("73")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40chapter30#pg74lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHRIMP BUTTER")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40chapter30#pg74lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("74")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41chapter31#pg77lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEQUILA-SPIKED COCKTAIL SAUCE WITH PERFECTLY BOILED SHRIMP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41chapter31#pg77lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("77")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42chapter32#pg78lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWEET POTATO CRISPS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42chapter32#pg78lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("78")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43chapter33#pg80lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOMEMADE TORTILLA CHIPS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43chapter33#pg80lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44chapter34#pg81lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOASTED CROSTINI")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44chapter34#pg81lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("81")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45chapter35#pg83lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CORNBREAD BLINIS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45chapter35#pg83lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("83")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46part04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CHAPTER FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46part04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SIT FOR A SPELL:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46part04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Reach for a Chair and Utensil")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63part05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("84")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47chapter36#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOMATO ASPIC")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47chapter36#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("86")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48chapter37#pg88lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MINTED WATERMELON & FETA SALAD")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48chapter37#pg88lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("88")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49chapter38#pg89lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPINACH SALAD WITH STRAWBERRIES, BACON, BLUE CHEESE & BOURBON VINAIGRETTE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49chapter38#pg89lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("89")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50chapter39#pg91lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JARS O’ CORNBREAD SALAD")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50chapter39#pg91lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("91")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51chapter40#pg92lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH CORN CAKES WITH FIELD PEA RELISH & LEMON AIOLI")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51chapter40#pg92lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("92")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52chapter24#pg95lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HERBED GOAT CHEESE & TOMATO TARTS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52chapter24#pg95lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("95")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53chapter42#pg98lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHICKEN TORTILLA SOUP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53chapter42#pg98lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("98")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54chapter43#pg100lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUM ’N’ COKE WINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54chapter43#pg100lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("100")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55chapter44#pg102lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRANDIED BAKED HAM WITH MUSTARD BUTTER")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55chapter44#pg102lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("102")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56chapter45#pg104lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAMBUNCTIOUS RIBLETS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56chapter45#pg104lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("104")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57chapter46#pg105lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DR PEPPER BRISKET & BRIE QUESADILLAS WITH PEACHY BBQ SAUCE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57chapter46#pg105lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("105")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58chapter47#pg109lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEPPERED BEEF TENDERLOIN & ROSEMARY-HORSERADISH CREAM SAUCE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58chapter47#pg109lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("109")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59chapter48#pg110lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRAWFISH BEIGNETS WITH JALAPEÑO TARTAR SAUCE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59chapter48#pg110lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("110")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60chapter49#pg112lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARINATED SHRIMP, TOMATO & MOZZARELLA SALAD")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60chapter49#pg112lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("112")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61chapter50#pg115lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PASCAL’S MANALE BBQ SHRIMP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61chapter50#pg115lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("115")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62chapter51#pg116lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DICKIE BRENNAN’S OYSTER PAN ROAST")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62chapter51#pg116lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("116")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63part05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CHAPTER FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63part05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("LIQUID ASSETS:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63part05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Cocktails and Beverages")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63part05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("118")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64chapter52#pg120lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIMM’S CUP, PLEASE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64chapter52#pg120lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("120")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65chapter53#pg122lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GIN YUMMIES")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65chapter53#pg122lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("122")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66chapter54#pg123lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRAWBERRY-BASIL MARGARITAS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66chapter54#pg123lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("123")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67chapter55#pg125lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEACH-BERRY SANGRIA")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67chapter55#pg125lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("125")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68chapter56#pg126lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STANLEY’S JULEPS WITH HONEYDEW-MINT SORBET")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68chapter56#pg126lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("126")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69chapter57#pg128lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honeydew-Mint Sorbet")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69chapter57#pg128lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("128")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70chapter58#pg129lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPLE BRANDY DANDIES")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70chapter58#pg129lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("129")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71chapter59#pg131lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HONEYSUCKLE-WATERMELON REFRESHERS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71chapter59#pg131lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("131")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72chapter60#pg132lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PITCHER-PERFECT MIMOSAS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72chapter60#pg132lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("132")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73chapter61#pg133lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMFORT ’N’ SWEET TEA")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73chapter61#pg133lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("133")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg134lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Bloody Marys")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg134lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("134")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg134lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flavor Boosters")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg134lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("134")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg134lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garnishes")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg134lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("134")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg135lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloody Mary Base")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter62#pg135lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("135")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#party",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PARTY THEMES & MENUS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/75party#party",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('em', [_vm._v("136")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Year’s Day Celebration")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("136")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mardi Gras/Jazz Brunch")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("136")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridal/Graduation Shower")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("136")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afternoon Garden Party")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg136lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("136")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Shindig/Porch Party")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("137")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinco de Mayo Fiesta")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("137")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tailgate/Casual Fall Gathering")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("137")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elegant Fall/Holiday Fête")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75party#pg137lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("137")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/76sources#source",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SOURCES")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/76sources#source",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("138")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/77acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/77acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("139")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/78index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/78index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("140")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#table",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("TABLE OF EQUIVALENTS")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#table",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("144")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#pg144lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liquid/Dry Measurements")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#pg144lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("144")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#pg144lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lengths")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#pg144lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("144")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#pg144lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven Temperature")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79equivalents#pg144lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('em', [_vm._v("144")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-178c517e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06contents.vue
// module id = 72
// module chunks = 0